/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { candidateInterviewBookingDataStatusSchema } from './CandidateInterviewBookingDataStatusSchema'

export const candidateInterviewBookingDataSchema = z.object({
	id: z.string(),
	status: candidateInterviewBookingDataStatusSchema,
	candidateAttended: z.boolean().nullable(),
	meeting: z.object({
		type: z.union([
			z.literal('jobilla_meet'),
			z.literal('google_meet'),
			z.literal('teams'),
			z.literal('zoom'),
			z.literal('phone'),
			z.literal('in_person'),
			z.literal('custom'),
		]),
		startsAt: z.iso.datetime(),
		endsAt: z.iso.datetime(),
		joinableAt: z.iso.datetime(),
		expiresAt: z.iso.datetime(),
		duration: z.number(),
		locationDetails: z.string().nullable(),
		candidateLink: z.string().nullable(),
		recruiterLink: z.string().nullable(),
	}),
})

export type CandidateInterviewBookingDataSchema = z.infer<typeof candidateInterviewBookingDataSchema>
